"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CustomRouter = require("01_core/components/system/CustomRouter");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _authorityUtil = _interopRequireDefault(require("01_core/logics/authorityUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _KansaUnavailability = _interopRequireDefault(require("../common/components/layout/KansaUnavailability"));
var _kansaProgressActions = require("../progress/kansaProgressActions");
var _KansaAnswerMain = _interopRequireDefault(require("./KansaAnswerMain"));
var _KansaAnswerPreviousResult = _interopRequireDefault(require("./KansaAnswerPreviousResult"));
var _KansaAnswerRegisterEntry = _interopRequireDefault(require("./KansaAnswerRegisterEntry"));
var _KansaAnswerRegisterResult = _interopRequireDefault(require("./KansaAnswerRegisterResult"));
var _kansaAnswerActions = require("./kansaAnswerActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
class KansaAnswerContainer extends _react.default.Component {
  constructor(props) {
    super(props);
    const {
      changeSearchCondition,
      progessToDispContent,
      progessToKansaInfo,
      setKansaInfo,
      isNewWindow,
      keyDispContent,
      keyKansaTgtNendo,
      keyKansaTgtJigyoId
    } = props;

    // 別ウィンドウ用コンポーネント（isNewWindowがtrueの場合）を経由している場合、
    // propに設定されたパラメータを設定する
    if (isNewWindow) {
      let kansaInfo = {
        kansaTgtNendo: keyKansaTgtNendo,
        kansaTgtJigyoId: keyKansaTgtJigyoId
      };
      setKansaInfo(kansaInfo, keyDispContent, false);
    } else {
      // 通常の画面遷移の場合
      if (progessToDispContent !== undefined) {
        let kansaInfo = {
          kansaTgtNendo: progessToKansaInfo.kansaTgtNendo,
          kansaTgtJigyoId: progessToKansaInfo.kansaTgtJigyoId
        };
        // 監査進捗状況からの画面遷移の場合
        switch (progessToDispContent) {
          case _kansaAnswerActions.CONTENTS.PROGRESS_TO_ANSWER_REFER:
            // 監査回答表示
            setKansaInfo(kansaInfo, _kansaAnswerActions.CONTENTS.REFER, true);
            break;
          case _kansaAnswerActions.CONTENTS.PROGRESS_TO_ANSWER_REGISTER:
            // 監査回答登録
            setKansaInfo(kansaInfo, _kansaAnswerActions.CONTENTS.REGISTER, true);
            break;
          default:
            break;
        }
      }
    }

    // 機能利用可否判定の初期値
    this.state = {
      avail: true
    };

    // 担当の監査対象事業のみ表示の初期値
    // 対策本部権限の場合ON
    const tantoOnlyFlg = !_authorityUtil.default.hasPermission(this.props.pms, _CodeConsts.CODE.KANSA_USAGE.CODE_ALLUSEPERMISSION) && !_authorityUtil.default.hasPermission(this.props.pms, _CodeConsts.CODE.KANSA_USAGE.CODE_LIMITEDUSEPERMISSION) ? true : false;
    changeSearchCondition('tantoOnlyFlg', tantoOnlyFlg);
  }
  componentDidMount() {
    const {
      changeSearchCondition
    } = this.props;

    // 機能利用可否判定（constructor から移動）
    this.props.callAPI(_APIs.KANSA_AVAILABILITY).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        // 機能利用可否判定結果を保持
        this.setState({
          avail: response.data.availability
        });
        changeSearchCondition('gyomuCdAvail', response.data.gyomuCd);
        // 担当する業務内容の初期値を設定
        if (response.data.gyomuCd === _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_1 || response.data.gyomuCd === _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_2) {
          changeSearchCondition('gyomuCd', response.data.gyomuCd);
        }
      }
    }).catch(e => {
      // アンマウント/二重送信は無視
      if ((e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED || (e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.CALLING) {
        return;
      }
      // 他の理由は従来どおり上位に伝播（withCallAPI が InfoBar 等を出す）
      throw e;
    });
  }
  componentWillUnmount() {
    this.props.clear();
  }
  render() {
    const {
      dispContent,
      kansaInfo,
      pms,
      progessToBtnProps,
      checkDirty,
      goMain,
      intl,
      goProgressMain
    } = this.props;
    let transitionProps = {
      kansaInfo
    };

    // 機能利用不可の場合は機能利用不可画面を表示する
    if (!this.state.avail) {
      return /*#__PURE__*/_react.default.createElement(_KansaUnavailability.default, {
        titleLabelId: _labelConsts.LABEL.KANSA_KANSA_ANSWER
      });
    }
    if (progessToBtnProps === undefined) {
      transitionProps['btnProps'] = {
        label: intl.formatMessage({
          id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
        }),
        onClick: function () {
          let search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          return () => checkDirty(() => goMain(search));
        }
      };
    } else {
      // 監査進捗状況からの画面遷移の場合
      transitionProps['btnProps'] = {
        label: progessToBtnProps.label,
        onClick: function () {
          let search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          return () => checkDirty(() => goProgressMain(search));
        }
      };
    }
    switch (dispContent) {
      // 監査回答（検索画面）
      case _kansaAnswerActions.CONTENTS.MAIN:
        return /*#__PURE__*/_react.default.createElement(_KansaAnswerMain.default, {
          pms: pms
        });

      // 監査回答登録
      case _kansaAnswerActions.CONTENTS.REGISTER:
        return /*#__PURE__*/_react.default.createElement(_KansaAnswerRegisterEntry.default, _extends({}, transitionProps, {
          returnBtn: className => /*#__PURE__*/_react.default.createElement(_CButton.default, {
            negative: true,
            autoWidth: true,
            className: className,
            onClick: transitionProps.btnProps.onClick(false)
          }, transitionProps.btnProps.label)
        }));

      // 監査回答表示
      case _kansaAnswerActions.CONTENTS.REFER:
        return /*#__PURE__*/_react.default.createElement(_KansaAnswerRegisterResult.default, _extends({}, transitionProps, {
          returnBtn: className => /*#__PURE__*/_react.default.createElement(_CButton.default, {
            negative: true,
            autoWidth: true,
            className: className,
            onClick: transitionProps.btnProps.onClick(false)
          }, transitionProps.btnProps.label)
        }));

      // 監査回答表示（前年度）
      case _kansaAnswerActions.CONTENTS.ZENNENDO:
        return /*#__PURE__*/_react.default.createElement(_KansaAnswerPreviousResult.default, transitionProps);

      // 監査回答結果
      case _kansaAnswerActions.CONTENTS.RESULT:
        return /*#__PURE__*/_react.default.createElement(_KansaAnswerRegisterResult.default, _extends({}, transitionProps, {
          returnBtn: className => /*#__PURE__*/_react.default.createElement(_CButton.default, {
            negative: true,
            autoWidth: true,
            className: className,
            onClick: transitionProps.btnProps.onClick(true)
          }, transitionProps.btnProps.label)
        }));

      // 上記以外の場合
      default:
        return null;
    }
  }
}
const mapStateToProps = state => {
  return {
    loginUserInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
    dispContent: state.kansaAnswer.dispContent,
    kansaInfo: state.kansaAnswer.kansaInfo,
    shareCondition: state.kansaShareCondition,
    setEntryResult: state.kansaAnswer.setEntryResult
  };
};
const mapDispatchToProps = dispatch => {
  return {
    goMain: search => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.GO_MAIN](search)),
    goRefer: kansaInfo => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.GO_REFER](kansaInfo)),
    goRegister: kansaInfo => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.GO_REGISTER](kansaInfo)),
    clear: () => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.CLEAR]()),
    setContent: content => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_CONTENT](content)),
    setKansaInfo: (kansaInfo, dispContent, isProgress) => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_KANSA_INFO](kansaInfo, dispContent, isProgress)),
    changeSearchCondition: (key, value) => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.CHANGE_SEARCH_CONDITION](key, value)),
    goProgressMain: search => dispatch(_kansaProgressActions.kansaProgressActions[_kansaProgressActions.TYPES.GO_MAIN](search))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CustomRouter.withRouter)((0, _CallAPI.withCallAPI)(KansaAnswerContainer))));